export default __webpack_public_path__ + "static/media/ieeeucsc.82b288f4.png";